/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("AiWritingAssistant4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * @class AiWritingAssistant4STBehavior
   * @memberOf classes
   * @extends classes.StyleBehaviorBase
   */
  cls.AiWritingAssistant4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.AiWritingAssistant4STBehavior.prototype */ {
      __name: "AiWritingAssistant4STBehavior",

      usedStyleAttributes: ["aiWritingAssistant"],
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const widget = controller.getWidget();
        if (widget?.setAiWritingAssistant) {
          const aiWritingAssistant = controller.getAnchorNode().getStyleAttribute("aiWritingAssistant");
          if (aiWritingAssistant) {
            widget.setAiWritingAssistant(this.isSAYesLike(aiWritingAssistant));
          }
        }
      }
    };
  });
});
